import { Alert } from 'src/components/Alert/Alert'
import { Container } from 'src/components/Container/Container'
import { Headline } from 'src/components/Headline/Headline'

import type { AlertProps } from 'src/components/Alert/Alert'
import type { InfoboxModule } from 'src/types/Module'

export const Infobox = ({ bgColor, headline, text }: InfoboxModule) => {
  const variant: Record<InfoboxModule['bgColor'], AlertProps['variant']> = {
    '#e7f4e4': 'success',
    '#e1f3f8': 'info',
    '#fff1d2': 'warning',
    '#f9dede': 'error',
  }

  return (
    <Container>
      <Alert variant={variant[bgColor]}>
        <Headline variant="h4" style={{ marginTop: -3, marginBottom: 5 }}>
          {headline}
        </Headline>
        <div dangerouslySetInnerHTML={{ __html: text }} style={{ color: '#000000' }} suppressHydrationWarning />
      </Alert>
    </Container>
  )
}
